<db-dialog-wrapper [dialog]="this" [width]="'580px'" [height]="'510px'">
  <div class="db-whats-new" dbCustomScrollbar>
    <div class="db-whats-new__logo">
      <h4>What's New</h4>
      <p>{{todaysDate | dbDate : 'MMM dd, y'}}</p>
    </div>
    <div class="db-whats-new__versions">
      <div class="db-whats-new__section">
        <div [innerHTML]="whatsNewContent | safeHtml"></div>
      </div>
      <!--<div class="db-whats-new__prev">
        <p>Missed an update?</p>
        <p>Check out our previous change logs</p>
      </div>-->
    </div>
  </div>
</db-dialog-wrapper>
